// removed by extract-text-webpack-plugin
module.exports = {"tiny":"380px","mobile":"768px","medium":"769px","large":"1024px","white":"#ffffff","whiteSmoke":"#f1f1f1","whiteFog":"#f9f9f9","whiteGrey":"#d8d8d8","black":"#2a2a2a","grey":"#9d9d9d","lightGrey":"#ccc","primary":"#d0103a","secondary":"#d0103a","tertiary":"#d0103a","quaternary":"#d0103a","error":"#e32438","success":"#79d38a","inactive":"#c6c6c6","billPrimary":"#077bc2"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/interstitiel/offer/ModalOfferComponent.scss
// module id = 1004
// module chunks = 0